import { useMemo } from "react";

import useMaterialsByCode from "fe-shared/src/hooks/useMaterialsByCode";

import { BusinessRole, TireMaterialConfig } from "fe-shared/src/types/domain";
import { CorrectionMaterial } from "../types";

const useEstimatedWeight = (
  materials: CorrectionMaterial[],
  businessRoles: BusinessRole[]
) => {
  const materialsByCode = useMaterialsByCode(businessRoles) as {
    [key: string]: TireMaterialConfig;
  };

  return useMemo(
    () =>
      Math.round(
        materials.reduce((sum, m) => {
          const defaultWeight =
            materialsByCode[m.materialCode]?.standardWeight || 0;

          return sum + m.units.unitQuantity * defaultWeight;
        }, 0)
      ),
    [materials, materialsByCode]
  );
};

export default useEstimatedWeight;
